module.exports = __webpack_public_path__ + "img/2h.3a0fb1f9.png";